import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";
import { ApolloError } from "@apollo/client";
import { ProductFiltersOptionOrder } from "src/types/graphql.d";

interface ProductFiltersOptionOrderData {
  productFiltersOptionOrder: ProductFiltersOptionOrder | undefined;
}

export const PRODUCT_FILTERS_OPTION_ORDER = gql`
  query ProductFiltersOptionOrder {
    productFiltersOptionOrder {
      category {
        slug
        order
      }
    }
  }
`;

const useProductFiltersOptionOrder = (): {
  data?: ProductFiltersOptionOrderData;
  loading: boolean;
  error?: ApolloError;
} => {
  const { data, loading, error } = useQuery<ProductFiltersOptionOrderData>(
    PRODUCT_FILTERS_OPTION_ORDER,
    {
      fetchPolicy: "cache-and-network",
    }
  );

  return {
    data,
    loading,
    error,
  };
};

export default useProductFiltersOptionOrder;
